'use client';

import { createFileRoute } from '@tanstack/react-router';
import GeneralStatusError from 'src/components/StatusError/General';

export const Route = createFileRoute('/_admin/error')({
	validateSearch: (search: Record<string, unknown>) => {
		return {
			occurredAt: (search.occurredAt as string) || undefined,
			method: (search.method as string) || undefined,
			statusCode: (search.statusCode as number) || undefined,
			uuid: (search.uuid as string) || undefined,
			time: (search.time as string) || undefined,
		};
	},
	component: ErrorPage,
});

function ErrorPage() {
	const { occurredAt, method, uuid, statusCode = 500, time } = Route.useSearch();

	return (
		<GeneralStatusError
			illustrationSrc="/public/warning.svg"
			label={`${statusCode} - Something went wrong`}
			occurredAt={occurredAt}
			method={method}
			uuid={uuid}
			time={time}
		/>
	);
}
